import { Recipient } from 'src/features/common/types/application/opportunity';

export type Address = {
  id?: string;
  street?: string;
  building?: string;
  suburb?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
  recipient?: Recipient;
};

export type AddressWithMeta = {
  address: Address;
  timeAtAddress: Date;
  addressType: ADDRESS_TYPES;
};

export enum ADDRESS_TYPES {
  OWNER = 'Owner',
  BOARDING = 'Boarding',
  WITH_PARENTS = 'Living with parents',
  RENTING = 'Renting',
  OTHER = 'Other',
}
